import React from 'react';
import { GlobalStyles } from 'react-magma-dom';

import '@babel/polyfill';

export const wrapPageElement = function ReactMagmaWrapper({ element }) {
  return (
    <>
      <GlobalStyles />
      {element}
    </>
  );
};
